export const REGEX_PATTERNS = {
  PREFERRED_TIME: /^(\d{4})-(0\d|1[0-2])-(0[1-9]|[12]\d|3[01]) ([01]\d|2[0-3]):([0-5]\d)$/,
  IS_MOBILE: /mobile|Mobile|Android|iP(hone|od|ad)/i,
  IS_DIGIT: /^\d+$/,
  NO_DIGITS: /\D/g,
  // @todo: поправить хотфикс не разобрался с регулярками
  FULL_NAME: /^[а-яА-ЯёЁӘәҒғҚқҢңӨөҰұҮүҺһІіa-zA-Z-\s]+$/,
  FULL_NAME_2: /[^а-яА-ЯёЁӘәҒғҚқҢңӨөҰұҮүҺһІіa-zA-Z-\s]/,
  HAS_SPECIAL_CHARS: /[^а-яА-ЯёЁӘәҒғҚқҢңӨөҰұҮүҺһІіa-zA-Z\s]/,
  FORMAT_NUMBER: /(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/,
};
